import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index/indexPage.vue'),
    meta: { title: '雅安数字员工总览' }
  },
  {
    path: '/ing',
    name: 'ing',
    component: () => import('../views/ing/ing.vue'),
    meta: { title: '接入网质差工单在途详情' }
  },
  {
    path: '/zqing',
    name: 'zqing',
    component: () => import('../views/zqing/ing.vue'),
    meta: { title: '政企在途工单通报' }
  },
  {
    path: '/zqfault',
    name: 'zqfault',
    component: () => import('../views/zqfault/ing.vue'),
    meta: { title: '政企在途工单详情' }
  },
  {
    path: '/wirelessing',
    name: 'wirelessing',
    component: () => import('../views/wirelessing/ing.vue'),
    meta: { title: '无线在途工单详情' }
  },
  {
    path: '/cting',
    name: 'cting',
    component: () => import('../views/cting/ing.vue'),
    meta: { title: '定制化小微在途工单详情' }
  },
  {
    path: '/fbing',
    name: 'fttrbing',
    component: () => import('../views/fttrbing/ing.vue'),
    meta: { title: 'FTTR-B在途工单详情' }
  },
  {
    path: '/tysling',
    name: 'tysling',
    component: () => import('../views/tysling/ing.vue'),
    meta: { title: '天翼视联在途工单详情' }
  },
  {
    path: '/hymjing',
    name: 'hymjing',
    component: () => import('../views/hymjing/ing.vue'),
    meta: { title: '行业魔镜在途工单详情' }
  },
  {
    path: '/sum',
    name: 'sum',
    component: () => import('../views/sum/SumViewSet.vue'),
    meta: { title: '接入网质差工单汇总' }
  },
  {
    path: '/rate',
    name: 'rate',
    component: () => import('../views/rate/rateViewSet.vue'),
    meta: { title: '速率大屏' }
  },
  {
    path: '/ipran',
    name: 'ipran',
    component: () => import('../views/ipran/repeat.vue'),
    meta: { title: 'IPRAN重复告警故障工单' }
  },
  {
    path: '/dualpressure',
    name: 'dualpressure',
    component: () => import('../views/dualpressure/ing.vue'),
    meta: { title: '集约化双压降工单管控' }
  },
  {
    path: '/release-upload',
    name: 'release-upload',
    component: () => import('../views/release/ReleaseUpload.vue'),
    meta: { title: 'Teleterm 升级包发布' }
  },
  {
    path: '/ip-query',
    name: 'ip-query',
    component: () => import('../views/ipquery/IpQuery.vue'),
    meta: { title: 'IP/接入号批量查询' }
  },
  {
    path: '/szha',
    name: 'szha',
    component: () => import('../views/szha/ing.vue'),
    meta: { title: '数智护安打卡率日报' }
  },
  {
    path: '/tyslcheck',
    name: 'tyslcheck',
    component: () => import('../views/tyslcheck/ing.vue'),
    meta: { title: '天翼视联巡检' }
  },
  {
    path: '/ctseelink',
    name: 'ctseelink',
    component: () => import('../views/ctseelink/ing.vue'),
    meta: { title: '天翼视联智能巡检' }
  },
  {
    path: '/screen/ctseelink',
    name: 'ctseelink_screen',
    component: () => import('../views/ctseelink/screen.vue'),
    meta: { title: '雅安平安校园天翼视联大屏', screen: true }
  },
  {
    path: '/tyslwarn',
    name: 'tyslwarn',
    component: () => import('../views/tyslwarn/ing.vue'),
    meta: { title: '天翼视联预警工单' }
  },
  {
    path: '/zhfxj',
    name: 'zhfxj',
    component: () => import('../views/zhfxj/ing.vue'),
    meta: { title: '智慧机房巡检' }
  },
  {
    path: '/visitcheck',
    name: 'visitcheck',
    component: () => import('../views/visitcheck/ing.vue'),
    meta: { title: '上门拜访打卡' }
  },
  {
    path: '/channel',
    name: 'channel',
    component: () => import('../views/channel/ing.vue'),
    meta: { title: '渠道厅店激励' }
  },
  {
    path: '/acl',
    name: 'acl',
    component: () => import('../views/acl/ing.vue'),
    meta: { title: '访问门禁管理' }
  },
  {
    path: '/:catchAll(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  // base 取 publicPath（生产 '/'，dev 构建注入 '/devtest/'），否则 devtest 子路径下路由匹配不上
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '此页面还未正式使用'
  next()
})

export default router